import React from 'react';
import { useSelector } from 'react-redux';

// Common components
import INCSUBNavbar from '../components/common/Navbar';
import INCSUBSidebar from '../components/common/Sidebar';

// Pages and modules
import INCSUBuser from './user/user';
import INCSUBroleanagement from './RoleManagement/INCSUBroleanagement';
import INCSUBPools from '../pages/pools/Pools';
import INCSUBPlatforms from './platforms/Platforms';
import INCSUBRevenue from '../components/FinancialsInsights/Revenue';
import INCSUBfeedback from '../pages/feedback/feedback';
import INCSUBComplaints from './complaints/Complaints';
import INCSUBPoolverification from '../components/pool verification/poolVerification';
import INCSUBPoolVerificationDetails from './pool Verification/poolVerificationDetails';
import INCSUBUserDetails from './user/userprofile/UserDetails';
import INCSUBCustomNotification from './notification/Notification';
import INCSUBSettings from '../components/settings/settings';

import './styleDashboard.css';
import INCSUBUserPayments from './userPayments/paymentVerification';

/**
 * INCSUBDashboard Component
 * 
 * This component acts as a central hub for rendering all dashboard-related views
 * based on the `routeStatus` stored in Redux. It includes a sidebar and navbar
 * and conditionally loads the appropriate module/component.
 * 
 * @returns {JSX.Element} The dashboard layout with dynamic content area.
 */
function INCSUBDashboard() {
    // Redux state: determines which component to render
    const routeStatus = useSelector((state) => state.common.routeStatus);

    return (
        <div className='INCSUBDashboard_main_page'>
            {/* Top navigation bar */}
            <INCSUBNavbar />

            <div className='INCSUBDashboard_main_page_container'>
                {/* Sidebar navigation */}
                <INCSUBSidebar />

                {/* Main content area: conditionally render based on routeStatus */}
                <div className='INCSUBDashboard_component_container'>
                    {routeStatus === '/rolemanagement' && <INCSUBroleanagement />}
                    {routeStatus === '/financialinsights' && <INCSUBRevenue />}
                    {routeStatus === '/user' && <INCSUBuser />}
                    {routeStatus === '/userPersonalDetails' && <INCSUBUserDetails />}
                    {routeStatus === '/pools' && <INCSUBPools />}
                    {routeStatus === '/poolverification' && <INCSUBPoolverification />}
                    {routeStatus === '/userPayment'&& <INCSUBUserPayments/>}
                    {routeStatus === '/poolverification/poolverificationdetails' && <INCSUBPoolVerificationDetails />}
                    {routeStatus === '/customnotification' && <INCSUBCustomNotification />}
                    {routeStatus === '/platforms' && <INCSUBPlatforms />}
                    {routeStatus === '/complaints' && <INCSUBComplaints />}
                    {routeStatus === '/feedback' && <INCSUBfeedback />}
                    {routeStatus === '/settings' && <INCSUBSettings />}
                </div>
            </div>
        </div>
    );
}

export default INCSUBDashboard;
